
import Navbar from "../navbar/navbar"

const Submit = () => {
    return ( 
        <>
        <div className="header-area">
        <div id="home" className="contact-header-area  bg_cover">
          <Navbar />
          <div className=" d-flex align-items-center">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="header-content text-center">
                    <h2 className="header-title2">CALL FOR PAPERS</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <h1 className="text-center py-4">Link will be updated soon.</h1>
</>
     );
}
 
export default Submit;